import { DrawerModalAction } from "./drawer-modal-action";
import { DrawerModalRepositoryInterface } from "./drawer-modal-repository-interface";
import { updateModalsCloseDrawerModal } from "@src/reducers/your-reducer";
import store from "@src/reducers/store";

export class DrawerModalRepository implements DrawerModalRepositoryInterface {
  private store;

  constructor(_store = store) {
    this.store = _store;
  }

  updateModalsCloseDrawerModal(drawerModalAction: DrawerModalAction) {
    this.store.dispatch(
      updateModalsCloseDrawerModal(drawerModalAction.build()),
    );
  }
}
